// Copied from the J7 spike (spikes/media-export), validated there.
export type Size = { w: number; h: number };

/** Resize plan to a target long edge: x0.5 steps while more than 2x too big, then the exact target; never enlarges. */
export function planResize(srcW: number, srcH: number, longEdge: number): Size & { steps: Size[] } {
  const srcLong = Math.max(srcW, srcH);
  if (srcLong <= longEdge) return { w: srcW, h: srcH, steps: [] };
  const at = (long: number): Size => ({ w: Math.round((srcW * long) / srcLong), h: Math.round((srcH * long) / srcLong) });
  const steps: Size[] = [];
  let cur = srcLong;
  while (cur > 2 * longEdge) {
    cur = Math.round(cur / 2);
    steps.push(at(cur));
  }
  const target = at(longEdge);
  steps.push(target);
  return { ...target, steps };
}

/** Thumbhash input must be at most 100x100 on both sides (portrait photos included). */
export function thumbSize(srcW: number, srcH: number, max = 100): Size {
  const scale = Math.min(1, max / Math.max(srcW, srcH));
  return { w: Math.max(1, Math.round(srcW * scale)), h: Math.max(1, Math.round(srcH * scale)) };
}
